import { appendQueryParameters } from '@flowio/web-sdk';
import { isFeatureEnabled } from '../features';
import globalFeatures from '../constants/features';
/**
 *
 * @param {string} url
 * @param {string} language
 * @returns {string}
 */
export default function addLanguageParam(
  /** @type {string} */ url,
) {
  let language;
  return isFeatureEnabled(globalFeatures.USE_SELECTED_LANGUAGE).then((isUseSelectedLangEnabled) => {
    const langAttribute = document.documentElement.getAttribute('lang');
    if (isUseSelectedLangEnabled && langAttribute) {
      language = langAttribute;
    } else {
      language = window.navigator.language;
    }
    if (language) {
      return appendQueryParameters(url, { language });
    }

    return url;
  })
  .catch(() => url);
}



// WEBPACK FOOTER //
// ./static/js/v0/utilities/add-language-param.js